var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.identityVerificationRequired && _vm.isVisible)?_c('gl-alert',{attrs:{"title":_vm.title,"primary-button-text":_vm.$options.i18n.buttonText,"primary-button-link":_vm.identityVerificationPath,"dismissible":_vm.dismissible,"variant":"danger"},on:{"dismiss":_vm.dismissAlert}},[_vm._v("\n  "+_vm._s(_vm.$options.i18n.description)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }